import PanelLeftCloseIcon from '@/assets/svg/header/panel-left-close.svg';
import PanelLeftOpenIcon from '@/assets/svg/header/panel-left-open.svg';
import { useLayoutSlice } from '@/stores/selectors';

import { ToggleButton } from './SidebarToggle.styled';

export const SidebarToggle = () => {
  const { isSidebarCollapsed, toggleSidebar } = useLayoutSlice();

  const PanelIcon = isSidebarCollapsed ? PanelLeftOpenIcon : PanelLeftCloseIcon;

  return (
    <ToggleButton
      color="tertiary"
      variant="ghost"
      size="xs"
      aria-label={isSidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
      aria-expanded={!isSidebarCollapsed}
      onClick={toggleSidebar}
    >
      <PanelIcon />
    </ToggleButton>
  );
};
